import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Loader2 } from 'lucide-react';
import api from '../lib/api';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) pollStatus(0);
  }, [sessionId]);

  const pollStatus = async (attempt) => {
    if (attempt >= 5) {
      setStatus('timeout');
      return;
    }
    try {
      const { data } = await api.get(`/payments/status/${sessionId}`);
      if (data.payment_status === 'paid') {
        setStatus('success');
      } else if (data.status === 'expired') {
        setStatus('expired');
      } else {
        setTimeout(() => pollStatus(attempt + 1), 2000);
      }
    } catch {
      setTimeout(() => pollStatus(attempt + 1), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-[#070A1A] flex items-center justify-center px-4" data-testid="payment-success-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="glass-card p-12 text-center max-w-md"
      >
        {status === 'checking' && (
          <>
            <Loader2 size={48} className="text-[#D4AF37] mx-auto mb-4 animate-spin" />
            <h2 className="font-['Playfair_Display'] text-xl text-[#FFFFF0]">Confirming your passage...</h2>
            <p className="text-sm text-[#BDB2C4] mt-2">The cards are preparing your space.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={48} className="text-[#D4AF37] mx-auto mb-4" />
            <h2 className="font-['Playfair_Display'] text-xl text-[#FFFFF0]">Welcome to unlimited guidance.</h2>
            <p className="text-sm text-[#BDB2C4] mt-2">Your sacred space is now fully open.</p>
            <button onClick={() => navigate('/home')} className="btn-primary mt-6" data-testid="payment-continue-btn">
              Enter the Room
            </button>
          </>
        )}
        {(status === 'expired' || status === 'timeout') && (
          <>
            <h2 className="font-['Playfair_Display'] text-xl text-[#FFFFF0]">Something went awry.</h2>
            <p className="text-sm text-[#BDB2C4] mt-2">Please try again or contact support.</p>
            <button onClick={() => navigate('/paywall')} className="btn-primary mt-6" data-testid="payment-retry-btn">
              Try Again
            </button>
          </>
        )}
      </motion.div>
    </div>
  );
}
